import React from 'react'
import PropTypes from 'prop-types'
import DatetimeUtils from "core/gd/utils/datetime-utils"

export default function UI5CalendarMonthHeader(props) {

    const firstDayOfWeekMoment = DatetimeUtils.calendarMonthViewFirstDate(Moment());

    const weekDays = []
    while(weekDays.length < 7) {
        weekDays.push(firstDayOfWeekMoment.format(props.headerDOWFormat))
        firstDayOfWeekMoment.add(1, 'day')
    }

    return (
        <div className="month-header">
            {_.map(weekDays, wd=><div key={wd} className="weekday">{wd}</div>)}
        </div>
    )
}

UI5CalendarMonthHeader.propTypes = {
    headerDOWFormat : PropTypes.string,
}

UI5CalendarMonthHeader.defaultProps = {
    headerDOWFormat : 'dd',
}